/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Pricing_TitleInputs */

const en_b2b_pricing_title = /** @type {(inputs: B2b_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise Performance. Zero Monthly Drag.`)
};

const es_b2b_pricing_title = /** @type {(inputs: B2b_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento Empresarial. Cero Arrastre Mensual.`)
};

const fr_b2b_pricing_title = /** @type {(inputs: B2b_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performances d'entreprise. Zéro frais mensuels fixes.`)
};

const de_b2b_pricing_title = /** @type {(inputs: B2b_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise-Leistung. Null monatlicher Ballast.`)
};

const id_b2b_pricing_title = /** @type {(inputs: B2b_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performa Perusahaan. Tanpa Hambatan Bulanan.`)
};

/** @type {(inputs: B2b_Pricing_TitleInputs) => LocalizedString} */
const ja_b2b_pricing_title = en_b2b_pricing_title;

/** @type {(inputs: B2b_Pricing_TitleInputs) => LocalizedString} */
const zh_b2b_pricing_title = en_b2b_pricing_title;

/** @type {(inputs: B2b_Pricing_TitleInputs) => LocalizedString} */
const ar_b2b_pricing_title = en_b2b_pricing_title;

/** @type {(inputs: B2b_Pricing_TitleInputs) => LocalizedString} */
const it_b2b_pricing_title = en_b2b_pricing_title;

/** @type {(inputs: B2b_Pricing_TitleInputs) => LocalizedString} */
const ru_b2b_pricing_title = en_b2b_pricing_title;

/** @type {(inputs: B2b_Pricing_TitleInputs) => LocalizedString} */
const pt_b2b_pricing_title = en_b2b_pricing_title;

/** @type {(inputs: B2b_Pricing_TitleInputs) => LocalizedString} */
const ko_b2b_pricing_title = en_b2b_pricing_title;

/**
* | output |
* | --- |
* | "Enterprise Performance. Zero Monthly Drag." |
*
* @param {B2b_Pricing_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_pricing_title = /** @type {((inputs?: B2b_Pricing_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Pricing_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_pricing_title(inputs)
	if (locale === "es") return es_b2b_pricing_title(inputs)
	if (locale === "fr") return fr_b2b_pricing_title(inputs)
	if (locale === "de") return de_b2b_pricing_title(inputs)
	if (locale === "ja") return ja_b2b_pricing_title(inputs)
	if (locale === "zh") return zh_b2b_pricing_title(inputs)
	if (locale === "ar") return ar_b2b_pricing_title(inputs)
	if (locale === "id") return id_b2b_pricing_title(inputs)
	if (locale === "it") return it_b2b_pricing_title(inputs)
	if (locale === "ru") return ru_b2b_pricing_title(inputs)
	if (locale === "pt") return pt_b2b_pricing_title(inputs)
	return ko_b2b_pricing_title(inputs)
});